// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"a354412a","352":"b21651bb","437":"55de3487","453":"ed3810f9","629":"8d987b43","672":"c538361c"}[chunkId] + ".chunk.js";
};